import {hoverAt, marketTodayView} from '../charts/marketTodayView.js';

// Show all / Show fewer, the tile pressed (trades, bids or offers) and the trades' price (sale or
// dock) last as long as the page: redraws, other tabs and coming back to Overview keep them.
let expanded = false;
let view = 'trades';
let basis = 'sale';

/**
 * Home > Overview's Today's activity card (the handoff's "Market today", 4.1):
 * <market-today-card market="market" counts="info.counts">.
 * The view is worked out again only when the data, the width, Show all, the tile pressed or the
 * price changes; the template just reads it.
 */
export default function marketTodayCard() {
  return {
    restrict: 'E',
    scope: {market: '<', counts: '<'},
    template: require('../views/market-today-card.html'),
    link(scope, element) {
      function update() {
        scope.vm = marketTodayView({market: scope.market, counts: scope.counts, width: scope.width, expanded, view, basis});
        hideHover();
      }

      // The hover readout: the mark nearest the pointer along a row's strip (hoverAt), its price
      // and what it is. Plain DOM on pointer events, outside the digest, so moving the pointer
      // costs no watchers and nothing runs while it rests. A tap shows it too.
      const card = element[0];
      let hovering = false;

      function hideHover() {
        if (!hovering) {
          return;
        }
        hovering = false;
        card.querySelectorAll('.hc-mt-hover, .hc-mt-tip').forEach(node => {
          node.hidden = true;
        });
      }

      function showHover(event) {
        const strip = event.target && event.target.closest ? event.target.closest('.hc-mt-strip') : null;
        const rows = strip && card.querySelector('.hc-mt-rows');
        const row = strip && scope.vm && scope.vm.rows[Number(strip.getAttribute('data-row'))];
        const s = strip && strip.getBoundingClientRect();
        const hit = row ? hoverAt(row.marks, event.clientX - s.left) : null;
        if (!hit) {
          hideHover();
          return;
        }
        const r = rows.getBoundingClientRect();
        const left = s.left - r.left + hit.x, top = s.top - r.top + 12;   // the strip's cy
        const ring = rows.querySelector('.hc-mt-hover'), tip = rows.querySelector('.hc-mt-tip');
        ring.style.left = `${left}px`;
        ring.style.top = `${top}px`;
        tip.textContent = '';
        hit.lines.forEach(line => {
          const div = card.ownerDocument.createElement('div');
          const value = div.appendChild(card.ownerDocument.createElement('span'));
          value.className = 'hc-mt-tip-value';
          value.textContent = line.value + (line.count > 1 ? ` ×${line.count}` : '');
          if (line.detail) {
            const detail = div.appendChild(card.ownerDocument.createElement('span'));
            detail.className = 'hc-mt-tip-detail';
            detail.textContent = ` · ${line.detail}`;
          }
          tip.appendChild(div);
        });
        ring.hidden = false;
        tip.hidden = false;
        hovering = true;
        // Above the ring, kept inside the rows block.
        const half = tip.offsetWidth / 2;
        tip.style.left = `${Math.min(Math.max(left, half), r.width - half)}px`;
        tip.style.top = `${top - 9}px`;
      }

      element.on('pointermove pointerdown', showHover);
      element.on('pointerleave', hideHover);
      scope.$on('$destroy', () => element.off('pointermove pointerdown pointerleave'));

      scope.toggle = () => {
        expanded = !expanded;
        update();
      };

      scope.showPrice = which => {
        if (which !== basis) {
          basis = which;
          update();
        }
      };

      // A tile shows its own rows below, in place of a link to its board.
      scope.showView = which => {
        if (which !== view) {
          view = which;
          update();
        }
      };

      // `width` is written by chart-width on the card body.
      scope.$watchGroup(['market', 'counts', 'width'], update);
    }
  };
}
